import { ReactNode } from 'react';
import { Caption, SubHeadingOne } from 'components/core';

interface BuilderSectionProps {
  title: string;
  hint?: string;
  children: ReactNode;
}

export const BuilderSection = ({ title, hint, children }: BuilderSectionProps) => (
  <div className="mb-4">
    <SubHeadingOne title={title} />
    {hint && <Caption text={hint} />}
    <div className="mt-2">{children}</div>
  </div>
);
